<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{ 'selectLanguageModal.title' | translate }}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" [mat-dialog-close]="true">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="overflow-hidden">
  <form [formGroup]="form">
    <div class="grid grid-cols-3 gap-4">
      <div
        *ngFor="let language of shortLanguages; let i = index"
        (click)="languageControl.setValue(language.name)"
        class="flex flex-row items-center gap-2 border rounded cursor-pointer p-2 transition-all ease-in-out hover:bg-neutral-100"
        [ngClass]="{
          'bg-chathams-blue-100 ring-brand-chathams-blue ring-offset-0 ring-2 border-transparent': languageControl.value === language.name,
          'border-gray-300': languageControl.value !== language.name
        }">
        <app-icon size="md" [iconName]="language.name"></app-icon>
        <span class="text-sm">{{LanguageLongTranslate[i] | translate}}</span>
      </div>
    </div>
  </form>
</mat-dialog-content>

<div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-4 pt-2">
  <flow-button theme="secondary" variation="outline" [mat-dialog-close]="true">{{'global.cancel' | translate}}</flow-button>
  <flow-button theme="primary" variation="fill" (onClick)="onChange()">{{'global.save' | translate}}</flow-button>
</div>
